import { useNavigate } from "react-router-dom";

export function useNavigation() {
  const history = useNavigate();
  return (url) => history(url);
}
